import { Timestamp } from "firebase/firestore";
import { Address } from './Address';
import { AmbassadorData } from "./User";
import { ComponentType, SurveyComponent, SurveyResponseValue } from "./SurveyTemplates";


export enum AwarenessCampaignStatus {
    PENDING = 'PENDING',
    IN_PROGRESS = 'IN_PROGRESS',
    COMPLETED = 'COMPLETED',
    CANCELLED = 'CANCELLED'
}

export type AwarenessCampaignDbData = {
    ID: string;
    name: string;
    deadline: Timestamp | undefined;
    createdAt?: Timestamp;
    /** For each ambassador added to the mission, indicate the number of addresses assigned to them. */
    assigned: { [email: string]: number };
    /** Number of addresses sensitized by each ambassador. */
    ambassadorVisitedCounts?: { [email: string]: number };
    ambassadorsStatus?: {
        [email: string]: AwarenessCampaignStatus;
    },
    createdBy?: {
        email: string;
        name: string;
    };
    mapImageURL?: string;
    status?: AwarenessCampaignStatus;
    addressesCount: number;
    addressesVisitedCount: number;
    /** Reference to survey template for dynamic reports */
    surveyTemplateID?: string;
}

export type AwarenessCampaignData = Omit<AwarenessCampaignDbData, "deadline" | "createdAt"> & {
    deadline: string | undefined;
    createdAt?: string;
}

export type AddressWithErrorsDbData = {
    ID: string;
    partnerID: string;
    address: Address;
    addressKey: string;
    errors: Record<string, number>;
    errorsCount: number;
    lat?: number;
    lng?: number;
    batchesCount?: number;
    assigned: AmbassadorData;
    visited: boolean;
    report?: SensitizationReportDbData;
    fromExternalSource: boolean;
    reportFiledAt?: Timestamp;
    refusalReason?: { [date: string]: string[] } | null;
}

export type AddressWithErrors = Omit<AddressWithErrorsDbData, "reportFiledAt" | "report"> & {
    reportFiledAt?: string;
    report?: SensitizationReport;
}

export type AddressWithErrorsAndCoordinates = Omit<AddressWithErrors, "lat" | "lng"> & {
    lat: number;
    lng: number;
}

export interface SensitizationReportDbData {
    templateID: string;
    
    // Response data keyed by component ID
    responses: { [componentID: string]: ComponentResponse };
    
    // Metadata
    submittedAt: Timestamp;
    submittedBy: {
        name: string;
        email: string;
    };
    
    isComplete: boolean;
  }

export type SensitizationReport = Omit<SensitizationReportDbData, "submittedAt"> & {
    submittedAt: string;
}
  interface ComponentResponse {
    componentID: string;
    componentType: ComponentType;
    label: SurveyComponent['label'];
    value: SurveyResponseValue;
  }